import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_INSTITUTIONITEM_LOAD_BY_ID,
    ACTION_INSTITUTIONITEMS_LOAD_BY_INSTITUTION_ID,
    ACTION_INSTITUTIONITEM_LOAD_FAILURE,
    ACTION_INSTITUTIONITEM_LOAD_SUCCESS,

    ACTION_INSTITUTIONITEM_SAVE,
    ACTION_INSTITUTIONITEM_SAVE_SUCCESS,
    ACTION_INSTITUTIONITEM_SAVE_FAILURE,

    ACTION_INSTITUTIONITEM_CREATE,
    ACTION_INSTITUTIONITEM_CREATE_SUCCESS,
    ACTION_INSTITUTIONITEM_CREATE_FAILURE,

    ACTION_INSTITUTIONITEM_CLEAR,
    ACTION_INSTITUTIONITEM_FILTER,

    InstitutionItemAction
} from '../actions/institutionItem';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from 'src/helpers/formErrorHelper';


export interface IInstitutionItemState {
    formData: Dtos.InstitutionItem | Dtos.InstitutionItem[],
    formDataInstitutioned: Dtos.InstitutionItemCategory[];
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    saveState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.InstitutionItem[];
    formFilteredDataInstitutioned: Dtos.InstitutionItemCategory[];
}

const initialState: IInstitutionItemState = {
    formData: undefined,
        formDataInstitutioned: undefined,
        formState: undefined,
        formProperties: undefined,
        validationFailures: undefined,
        lookups: undefined,
        loadState: {
            status: RequestState.None
        } as IRequestState,
        saveState: {
            status: RequestState.None
        } as IRequestState,
        updateState: {
            status: RequestState.None
        } as IRequestState,
        createState: {
            status: RequestState.None
        } as IRequestState,
        formFilter: {
            search: "",
            showInActive: false
        },
        formFilteredData: [],
        formFilteredDataInstitutioned: undefined,
};


function loading(state: IInstitutionItemState, _isLoading: boolean): IInstitutionItemState {
    const newState: IInstitutionItemState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(
    state: IInstitutionItemState,
    formData: Dtos.InstitutionItem | Dtos.InstitutionItem[],
    formDataInstitutioned: Dtos.InstitutionItemCategory[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): IInstitutionItemState {
    const newState: IInstitutionItemState = update(state, {
        formData: {
            $set: formData
        },
        formDataInstitutioned: {
            $set: formDataInstitutioned
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function filter(state: IInstitutionItemState, formFilter: IFormFilter): IInstitutionItemState {

    const formData: Dtos.InstitutionItem[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formFilteredData = formData ? formData.filter(p => (p.active == true || formFilter.showInActive) &&
        (formFilter.search == "" || p?.institutionItemTemplate?.name?.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)) : undefined;

    let formFilteredDataInstitutioned = [];
    if (state.formDataInstitutioned) {
        for (var i = 0; i < state.formDataInstitutioned.length; i++) {
            const filteredCategoryItems =
                state.formDataInstitutioned[i].institutionItems.filter(p => (p.active == true || formFilter.showInActive) &&
                    (formFilter.search == "" ||
                        (p?.institutionItemTemplate?.name != undefined && p?.institutionItemTemplate?.name.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1) ||
                        (p?.institutionItemTemplate?.description != undefined && p?.institutionItemTemplate?.description.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)
                    ));
            if (filteredCategoryItems.length > 0) {
                formFilteredDataInstitutioned.push({
                    ...state.formDataInstitutioned[i],
                    institutionItems: filteredCategoryItems
                });
            }
        }
    }

    const newState: IInstitutionItemState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        },
        formFilteredDataInstitutioned: {
            $set: formFilteredDataInstitutioned
        }
    });

    return newState;
}

function loadFailure(state: IInstitutionItemState, responseStatus: Dtos.ResponseStatus): IInstitutionItemState {
    const newState: IInstitutionItemState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: IInstitutionItemState, propertiesToClear?: string[]): IInstitutionItemState {

    if (!propertiesToClear) {
        const newState: IInstitutionItemState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: IInstitutionItemState, _isSaving: boolean): IInstitutionItemState {
    const newState: IInstitutionItemState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: IInstitutionItemState,
    formData: Dtos.InstitutionItem | Dtos.InstitutionItem[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): IInstitutionItemState {
    const newState: IInstitutionItemState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: IInstitutionItemState, responseStatus: Dtos.ResponseStatus): IInstitutionItemState {
    const newState: IInstitutionItemState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: IInstitutionItemState, _isCreating: boolean): IInstitutionItemState {
    const newState: IInstitutionItemState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: IInstitutionItemState,
    formData: Dtos.InstitutionItem,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): IInstitutionItemState {
    const newState: IInstitutionItemState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: IInstitutionItemState, responseStatus: Dtos.ResponseStatus): IInstitutionItemState {
    const newState: IInstitutionItemState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

const InstitutionItemReducer: Reducer<IInstitutionItemState> = (state: IInstitutionItemState = initialState, action: InstitutionItemAction) => {
    switch (action.type) {
        case ACTION_INSTITUTIONITEM_LOAD_BY_ID:
        case ACTION_INSTITUTIONITEMS_LOAD_BY_INSTITUTION_ID:
            return loading(state, true);
        case ACTION_INSTITUTIONITEM_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formDataInstitutioned, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_INSTITUTIONITEM_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_INSTITUTIONITEM_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_INSTITUTIONITEM_SAVE:
            return saving(state, true);
        case ACTION_INSTITUTIONITEM_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_INSTITUTIONITEM_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_INSTITUTIONITEM_CREATE:
            return creating(state, true);
        case ACTION_INSTITUTIONITEM_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_INSTITUTIONITEM_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_INSTITUTIONITEM_FILTER:
            return filter(state, action.formFilter);

    }

    return state;
}

export default InstitutionItemReducer;